export const VERTEX_LAYER_ID = "draft-vertices";
export const ZONE_LAYER_ID = "zones";
const MIN_VERTICES = 3;

export type MapClickAction = "add" | "finish" | "openZone" | "none";

interface MapClick {
  drawing: boolean;
  editing: boolean;
  layerId: string | undefined;
  vertexIndex?: number;
  pointCount: number;
}

/** What a click on the zone map does; clicking the first vertex closes the shape like a double-click. */
export function mapClickAction({ drawing, editing, layerId, vertexIndex, pointCount }: MapClick): MapClickAction {
  if (drawing) {
    return layerId === VERTEX_LAYER_ID && vertexIndex === 0 && pointCount >= MIN_VERTICES ? "finish" : "add";
  }
  return !editing && layerId === ZONE_LAYER_ID ? "openZone" : "none";
}
